// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customInput .cancelIcon {
  background: none;
  border: none;
  padding: 0;
  position: relative;
  z-index: 100;
}

.customInput .cancelIcon img {
  width: 12px;
  height: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomInput/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".customInput .cancelIcon {\n  background: none;\n  border: none;\n  padding: 0;\n  position: relative;\n  z-index: 100;\n}\n\n.customInput .cancelIcon img {\n  width: 12px;\n  height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
